<script lang="ts">
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha'
export default {
    name: 'InscriptionStep3',
    props: {
        data: { type: Object, required: true },
        validationRules : {type: Object, required : true},
        validation : {type: Object, required : true},
        translationName : { type : String, required : true },
        registerTried : { type : Boolean, required : false },
    },
    components: {
        VueHcaptcha,
    },
    emits: ['captchaVerified', 'updateData'],
    data: () => ({
        defaultApps : [],
    }),
    mounted () {
        this.defaultApps = this.data.access_requests
    },
    methods: {
        verifyCaptcha () {
            this.$emit('captchaVerified', true)
        },
        updateData(index: string | number, app: any) {
            this.defaultApps[index] = app
            this.$emit('updateData', { [`access_requests`]: this.defaultApps })
        },
        validateStep () {
            const selected = this.data.access_requests.filter((access: { asked: any; text: string | any[]; }) => access.asked && access.text && access.text.length > 49 && access.text.length < 501)
            return !!selected.length
        }
    },
}
</script>

<template>
    <div>
        <fieldset class="border-0 pa-0" id="access-rights-register">
            <legend aria-describedby="description-legend" class="font-weight-bold">
                Demande d'accès aux applications
                <span v-html="$config.public.form_label_required_text || '*'" />
            </legend>
            <InfoCard text="<b>Choisir au moins une application.<br>Il est possible de demander d'autres accès ultérieurement.</b>" level="danger" variant="flat"
                v-if="registerTried && !validateStep()"
            />
            <p id="description-legend" class="text-caption text-medium-emphasis" v-else>Choisir au moins une application. Il est possible de demander d'autres accès ultérieurement.</p>
            <template v-for="(app, i) in defaultApps" :key="i">
                <FormYesno
                    checkbox
                    :no-label="true"
                    data-key="asked"
                    :custom-id="app.application.slug + '-demande'"
                    :custom-label="app.application.title"
                    :validation="validation"
                    :validation-has-index="i"
                    :data="app"
                    :translation-name="`access_request`"
                    @update-data="updateData(i, { ...app, asked: $event })"
                />
                <template v-if="app.asked">
                    <span class="font-weight-bold">Motivations pour accéder à l'application : {{ app.application.title }}</span> 
                    <span v-html="$config.public.form_label_required_text || '*'" />
                    <!-- <InfoCard text="<b>Entre 50 caractères minimum et 500 caractères maximum.</b>" variant="flat" :level="(app.text && (app.text?.length < 50 || app.text?.length > 500)) || !app.text  ? 'warning' : 'info'" /> -->
                    <div class="text-caption"
                        :class="(app.text && (app.text?.length < 50 || app.text?.length > 500)) || !app.text ? 'text-error font-weight-bold' : 'text-medium-emphasis'"
                    >Entre 50 et 500 caractères maximum.</div>
                    <FormTextarea
                        :ref="`text${i}`"
                        :no-label="true"
                        data-key="text"
                        :custom-id="app.application.slug + '-text'"
                        :validation="validation"
                        :validation-has-index="i"
                        :data="app"
                        :translation-name="`access_request`"
                        @update-data="updateData(i, { ...app, text: $event })"
                    />
                </template>
            </template>
        </fieldset>

        <VueHcaptcha
            ref="hcaptcha"
            class="mt-3"
            :sitekey="$config.public.hcaptchaPublic"
            @verify="verifyCaptcha"
        />
    </div>
</template>
